export enum LocaleStorageKey  {
    USER_ID = 'userId'
}